export const updateLikedUserFollowing = (user, followingInfo) => {
  if(!followingInfo || !user) return user;
  const userToUpdate = user;
  userToUpdate.following = followingInfo.following;
  return userToUpdate;
}